export const GithubUrl = "https://github.com/pauljoegeorge";
export const LinkedinUrl = "https://www.linkedin.com/in/pauljoegeorge";
export const TwitterUrl = "https://twitter.com/pauljoegeorge";
